// Official Canadian maple leaf — from the Canadian flag
import mapleLeafImg from '@/assets/maple-leaf.png';

export default function MapleLeaf({ className = 'w-5 h-5' }: { className?: string }) {
  return (
    <img
      src={mapleLeafImg}
      alt="🍁"
      className={className}
      style={{ objectFit: 'contain' }}
      aria-hidden="true"
    />
  );
}
